export var getDictPhrase = function (dict, key) {
    return dict[key] || key;
};
//# sourceMappingURL=getDictPhrase.js.map